import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing plans.
 */
interface ListTransactionRequest {
  queryKey: [string, string, string, string, string];
}

interface ListOrderRequest {
  queryKey: [string, string, string, string, string, string];
}

interface ListPayoutRequest {
  queryKey: [string, string, string];
}

interface ListRefundRequest {
  queryKey: [string, string];
}

/**
 * Service class for handling plans.
 */
class TransactionService {
  static listTransaction(request: ListTransactionRequest) {
    const payment_status = request.queryKey[0];
    const order_status = request.queryKey[1];
    const payout_status = request.queryKey[2];
    const from_date = request.queryKey[3];
    const to_date = request.queryKey[4];

    return client.get(
      `admin/transaction/get-transaction-list?payment_status=${payment_status}&order_status=${order_status}&payout_status=${payout_status}&from_date=${from_date}&to_date=${to_date}`,
      request as AxiosRequestConfig
    );
  }

  static getListOrder(request: ListOrderRequest) {
    const payment_status = request.queryKey[0];
    const order_status = request.queryKey[1];
    const payout_status = request.queryKey[2];
    const from_date = request.queryKey[3];
    const to_date = request.queryKey[4];
    const search_text = request.queryKey[5];

    return client.get(
      `admin/transaction/get-order-list?payment_status=${payment_status}&order_status=${order_status}&payout_status=${payout_status}&from_date=${from_date}&to_date=${to_date}&search_text=${search_text}`,
      request as AxiosRequestConfig
    );
  }

  static getListPayout(request: ListPayoutRequest) {
    const from_date = request.queryKey[0];
    const to_date = request.queryKey[1];
    const search_text = request.queryKey[2];

    return client.get(
      `admin/transaction/get-payout-list?from_date=${from_date}&to_date=${to_date}&search_text=${search_text}`,
      request as AxiosRequestConfig
    );
  }

  static getListRefund(request: ListRefundRequest) {
    const from_date = request.queryKey[0];
    const to_date = request.queryKey[1];
    return client.get(
      `admin/transaction/get-refund-list?from_date=${from_date}&to_date=${to_date}`,
      request as AxiosRequestConfig
    );
  }

  static storePayoutData(request: any) {
    return client.put(`admin/transaction/store-payout/`, request);
  }

  static getFailedOrderList(request: any) {
    const from_date = request.queryKey[0];
    const to_date = request.queryKey[1];
    const search_text = request.queryKey[2];

    return client.get(
      `admin/transaction/get-fail-order-list?from_date=${from_date}&to_date=${to_date}&search_text=${search_text}`,
      request as AxiosRequestConfig
    );
  }

  static updatePaymentData(request: any) {
    return client.put(`admin/transaction/update-payment`, request);
  }
}

export { TransactionService };
